import SubmissionStatusLabel from "Components/Shared/SubmissionStatusLabel";
import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Button, Container, Table } from "semantic-ui-react";
import moment from "moment";

type TicketListProps = {
  submissions: any[];
  select: Function;
};

const TicketSubmissionList = ({ submissions, select }: TicketListProps) => {
  const { hasRole, roles } = useCheckRole();
  const canView = hasRole(roles.ticket.roles.select);
  const admin = hasRole(roles.admin);

  return (
    <Container fluid style={{ padding: "20px" }}>
      {renderTable(submissions, select, canView, admin)}
    </Container>
  );
};

const renderTable = (
  submissions: any[],
  select: Function,
  canView: Boolean,
  admin: Boolean
) => {
  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Customer</Table.HeaderCell>
          <Table.HeaderCell>Ticket #</Table.HeaderCell>
          {admin && <Table.HeaderCell>Portal Ref</Table.HeaderCell>}
          <Table.HeaderCell>Line Type</Table.HeaderCell>
          <Table.HeaderCell>CNO</Table.HeaderCell>
          {admin && <Table.HeaderCell>RH</Table.HeaderCell>}
          <Table.HeaderCell>From</Table.HeaderCell>
          <Table.HeaderCell>To</Table.HeaderCell>
          <Table.HeaderCell>MBN</Table.HeaderCell>
          <Table.HeaderCell>Associated</Table.HeaderCell>
          <Table.HeaderCell>Ranges</Table.HeaderCell>
          <Table.HeaderCell>Due Date</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          {canView && <Table.HeaderCell width={1}>Actions</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {submissions
          .sort((a, b) => {
            console.log(
              a.statuses.slice(-1)[0].dueDate,
              b.statuses.slice(-1)[0].dueDate
            );
            return moment(a.statuses.slice(-1)[0].dueDate).isAfter(
              moment(b.statuses.slice(-1)[0].dueDate)
            )
              ? 1
              : -1;
          })
          .map((submission: any) => (
            <Table.Row key={`tr-sub-${submission.attempt}`}>
              <Table.Cell>{submission.customer.name}</Table.Cell>
              <Table.Cell>{submission.caseId}</Table.Cell>
              {admin && <Table.Cell>{submission.portalRefNumber}</Table.Cell>}
              <Table.Cell>{submission.lineType}</Table.Cell>
              <Table.Cell>{submission.cno}</Table.Cell>
              {admin && <Table.Cell>{submission.rangeHolder}</Table.Cell>}
              <Table.Cell>{submission.originalPostalCode}</Table.Cell>
              <Table.Cell>{submission.postalCode}</Table.Cell>
              <Table.Cell>{submission.mbn}</Table.Cell>
              <Table.Cell>{submission.associatedNumbers}</Table.Cell>
              <Table.Cell>{submission.rangeNumbers}</Table.Cell>
              <Table.Cell>
                {moment(submission.statuses.slice(-1)[0].dueDate)
                  .utc()
                  .format("DD/MM/yyyy")}
              </Table.Cell>
              <Table.Cell>
                <SubmissionStatusLabel status={submission.status} />
              </Table.Cell>

              {canView && (
                <Table.Cell textAlign='left'>
                  <Button
                    primary
                    size='tiny'
                    onClick={() => select(submission.id)}
                  >
                    Select
                  </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};

export default TicketSubmissionList;
